// extracted by mini-css-extract-plugin
module.exports = {"content":"PromptModal_content__2v6hx","buttons":"PromptModal_buttons__Zd0W5"};